import type { VerificationDocType, UserRole } from './docTypeLabels';

/**
 * Required documents per role for `documents_verified_at` to be set.
 * Optional docs strengthen confidence but do not block verification.
 *
 * As of June 2026: requirements reduced to ONE document per role.
 * Everything else is optional (strengthens trust badge but doesn't block).
 *
 * NOTE: `business_license` and `unknown` are intentionally NOT included in
 * either list. They're admin-only / transitional types.
 */
export const REQUIRED_DOCS: Record<UserRole, VerificationDocType[]> = {
  broker: ['operating_authority'],
  carrier: ['operating_authority'],
  shipper: ['w9'],
  broker_carrier: ['operating_authority'],
};

export const OPTIONAL_DOCS: Record<UserRole, VerificationDocType[]> = {
  broker: ['surety_bond', 'w9'],
  carrier: ['certificate_of_insurance', 'w9'],
  shipper: [],
  broker_carrier: ['surety_bond', 'certificate_of_insurance', 'w9'],
};

export function getRequiredDocs(role: string | null | undefined): VerificationDocType[] {
  if (!role) return [];
  return REQUIRED_DOCS[role as UserRole] ?? [];
}

export function getOptionalDocs(role: string | null | undefined): VerificationDocType[] {
  if (!role) return [];
  return OPTIONAL_DOCS[role as UserRole] ?? [];
}
